import React from "react";
import Joi from "joi-browser";
import Form from "../common/form";
import { getSingle, updateSingle } from "../../services/tourService";
import { toast } from "react-toastify";
import BlockUi from "react-block-ui";
import TableTitle from "../common/tableTitle";
import { Table } from "semantic-ui-react";
import auth from "../../services/authService";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

class TourEditForm extends Form {
  state = {
    preferredDate: new Date(),
    data: {
      parent_first_name: "",
      parent_last_name: "",
      child_name: "",
      child_age: "",
      phone: "",
      email: "",
      preferred_tour_date:""
    },
    errors: {}
  };

  schema = {
    parent_first_name: Joi.string()
      .required()
      .label("Parent's First Name"),
    parent_last_name: Joi.string()
      .required()
      .label("Parent's Last NameEmail"),
    child_name: Joi.string()
      .required()
      .label("Child Name"),
    child_age: Joi.string()
      .required()
      .label("Child Age"),
    phone: Joi.string()
      .required()
      .label("Phone"),
    email: Joi.string()
      .required()
      .label("Email"),
    preferred_tour_date: Joi.string()
      .required()
      .label("Preferred Tour Date")
  };

  async populateAccount() {
    try {
      const accountId = this.props.match.params.id;

      this.setState({ blocking: true });
      const { data: account } = await getSingle(accountId);

      this.setState({ blocking: false });

      const dateData = this.mapingData(account);

      this.setState({
        preferredDate: dateData.preferredDate != "01/01/1970" && dateData.preferredDate != undefined && dateData.preferredDate != "" ? new Date(dateData.preferredDate) : "",
      });

      this.setState({ data: this.mapToViewModel(account) });
    } catch (ex) {
      if (ex.response && ex.response.status === 404)
        this.props.history.replace("/not-found");
    }
  }

  async componentDidMount() {
    await this.populateAccount();
  }

  mapingData(account) {
    return {
      preferredDate: account.preferred_tour_date
    };
  }

  mapToViewModel(account) {
    return {
      parent_first_name: account.parent_first_name,
      parent_last_name: account.parent_last_name,
      child_name: account.child_name,
      child_age: account.child_age,
      phone: account.phone,
      email: account.email,
      preferred_tour_date:account.preferred_tour_date
    };
  }

  doSubmit = async () => {
    try {
      const ledgerTypeId = this.props.match.params.id;

      const data = { ...this.state.data };
      data.id = parseInt(ledgerTypeId);
      this.setState({ blocking: true });

      let event = new Date(this.state.preferredDate);
      let date = JSON.stringify(event);
      date = date.slice(1, 11);
     
      data.preferred_tour_date = date;

      await updateSingle(data);
      this.setState({ blocking: false });
      toast.success("Tour has been updated successfully.");
      this.props.history.push("/web/tours");
    } catch (ex) {
      console.log(ex.response);
      if (ex.response && ex.response.status === 422) {
        const errors = { ...this.state.errors };

        if (ex.response.data.errors.name)
          errors.name = ex.response.data.errors.name;

        if (ex.response.data.errors.address)
          errors.address = ex.response.data.errors.address;

        if (ex.response.data.errors.phone)
          errors.phone = ex.response.data.errors.phone;

        if (ex.response.data.errors.account)
          errors.account = ex.response.data.errors.account;

        this.setState({ errors, blocking: false });
        // toast.warning("check validation errors.");
      }
    }
  };

  handleChangePreferredDate = date => {
    this.setState({
      preferredDate: date
    });
  };

  render() {
    const dashboardIcon = process.env.REACT_APP_URL + "/new_theme/bank.png";
    // if (auth.getCurrentUser().email != "company-unblocker@gondalgroup.ae") {
    //   return "Your are authorized to perform this action.";
    // }
    return (
      <BlockUi tag="div" blocking={this.state.blocking}>
        <TableTitle title="Update tour" icon="tag" color="white" iconPath={dashboardIcon} />
        <center>
          <form
            onSubmit={this.handleSubmit}
            className="ui error form"
            style={{ width: "50%" }}
          >
            <Table>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell colSpan="2">
                    Update tour
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                
              <Table.Row>
                  <Table.Cell width="8">
                    {this.renderInput("parent_first_name", "Parent First Name", "text")}
                  </Table.Cell>
                  <Table.Cell width="8">
                    {this.renderInput("parent_last_name", "Parent Last Name", "text")}
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell width="8">
                    {this.renderInput("child_name", "Child Name", "text")}
                  </Table.Cell>
                  <Table.Cell width="8">
                    {this.renderInput("child_age", "Child Age", "text")}
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell width="8">
                    {this.renderInput("phone", "Phone", "text")}
                  </Table.Cell>
                  <Table.Cell width="8">
                    {this.renderInput("email", "Email", "text")}
                  </Table.Cell>
                </Table.Row>

                <Table.Row>
                  <Table.Cell width="8">
                    
                    <label>
                      <b>Preferred Tour Date</b>
                    </label>
                    <br />
                    <DatePicker
                      selected={this.state.preferredDate}
                      onChange={this.handleChangePreferredDate}
                    />
                    <br />
                    <small>(day/month/year)</small>
                  </Table.Cell>
                  <Table.Cell width="8">
                    
                  </Table.Cell>
                </Table.Row>
               
                <Table.Row>
                  <Table.Cell>
                    {this.renderButton("Update")}
                    <Link to="/web/tours" className="ui secondary button">
                      Back
                    </Link>
                  </Table.Cell>
                  <Table.Cell></Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
          </form>
        </center>
      </BlockUi>
    );
  }
}

export default TourEditForm;
